import React from 'react'
import { Route, Switch } from 'react-router-dom'
// import TicketList from './TicketList'
// import DetailsList from './DetailsList'
import IntegralHome from './IntegralHome'
import IntegralDetails from './IntegralDetails'
// import IntegralDetails from './IntegralDetails.old'
import IntegralHomeV3 from './v3/IntegralHomeV3'


// 这里还没想到是要我这边匹配还是弄几个v几v几的版本
let IntegralEntry
switch (process.env['REACT_APP_CHANNEL']) {
  case 'trading':
    IntegralEntry = IntegralHomeV3
    break
  default:
    IntegralEntry = IntegralHome
}

class IntegralRouter extends React.PureComponent {
  render () {
    return <Switch>
      <Route path={window.PATH.INTEGRAL} component={IntegralEntry} exact />
      {/*<Route path={window.PATH.INTEGRAL_LIST} component={TicketList} />*/}
      <Route path={window.PATH.INTEGRAL_DETAILS} component={IntegralDetails} />
      <Route path={window.PATH.INTEGRAL_V3.HOME} component={IntegralHomeV3} />
    </Switch>
  }
}

export default IntegralRouter
